import { getFileNameExcel } from "helpers/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React from "react";
import ListExport from "./ListExport";

const ListExportInvoiceWareHouses = props => {
  return (
    <ListExport
      typeReport={TYPE_REPORT.INVOICE_WAREHOUSES}
      fileNameExport={getFileNameExcel("DanhSachPXK_NoiBo")}
    />
  );
};

export default ListExportInvoiceWareHouses;
